"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferencesSlider = void 0;
const run_when_visible_1 = require("../utils/run-when-visible");
const swiper_1 = require("swiper");
class ReferencesSlider {
    constructor(elements) {
        elements.forEach((element) => (0, run_when_visible_1.RunWhenVisible)(element, ReferencesSlider.initialize));
    }
    static async initialize() {
        const { Swiper, Autoplay } = await Promise.resolve().then(() => __importStar(require(
        /* webpackChunkName: "swiper" */
        'swiper')));
        Swiper.use([Autoplay, swiper_1.Navigation, swiper_1.Pagination]);
        new Swiper('.references-swiper', {
            autoplay: {
                delay: 12500,
                pauseOnMouseEnter: true,
            },
            grabCursor: true,
            spaceBetween: 30,
            slidesPerView: 'auto',
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        });
    }
}
exports.ReferencesSlider = ReferencesSlider;
